/**
 * Local seed data for Gideon Force content.
 * Aligns with YFC T&T brochure materials (Judges 6:12, March 14 2026 launch, prayer priorities PDF).
 */

/** Official launch — brochure: Chaguanas / national launch */
export const GIDEON_LAUNCH_ISO = '2026-03-14';

export const GIDEON_SCHEDULE = {
  launchIso: GIDEON_LAUNCH_ISO,
  /** Thursday 8–9 PM — Zoom */
  zoomWeekday: 4,
  /** Third Saturday monthly — hybrid corporate session */
  thirdSaturdayHybrid: true,
  /** First Saturday of Jan, Apr, Jul, Oct — quarterly Gideon Prayer Revival */
  quarterlyRevivalMonths: [0, 3, 6, 9],
};

export const GIDEON_PRAYER_POINTS_SEED = [
  {
    id: 'week-minus-1',
    weekLabel: 'Week -1',
    focus: "Our nation's children and youths",
    focalScripture: 'Psalm 127:3 | 1 John 2:14',
    points: [
      'Pray that you will remain focused in all things (self / family).',
      'Pray for the children and youth in your community to keep the right company.',
      'Pray that you will contribute to national revival.',
      'Pray that youths will not be afraid to ask for help in difficult times.',
      'Pray for a change of heart for any youth caught up in illicit activities.',
    ],
    order: 0,
  },
];

/** Supplementary list items for the page (brochure calendar PDF + commitments) */
export const GIDEON_RHYTHM_EVENTS = [
  {
    id: 'launch',
    titleKey: 'gideon.rhythm.launch',
    detailKey: 'gideon.rhythm.launchDetail',
  },
  {
    id: 'zoom-weekly',
    titleKey: 'gideon.rhythm.zoomWeekly',
    detailKey: 'gideon.rhythm.zoomWeeklyDetail',
  },
  {
    id: 'third-sat',
    titleKey: 'gideon.rhythm.thirdSaturday',
    detailKey: 'gideon.rhythm.thirdSaturdayDetail',
  },
  {
    id: 'quarterly-revival',
    titleKey: 'gideon.rhythm.quarterlyRevival',
    detailKey: 'gideon.rhythm.quarterlyRevivalDetail',
  },
  {
    id: 'podcast',
    titleKey: 'gideon.rhythm.podcast',
    detailKey: 'gideon.rhythm.podcastDetail',
  },
];

export const getGideonPrayerPoints = () => GIDEON_PRAYER_POINTS_SEED;

/** @deprecated Use rhythm + calendar — kept for dashboards still importing events list */
export const GIDEON_EVENTS_SEED = [
  { id: 'gideon-launch', title: 'Gideon Force Launch', schedule: 'March 14, 2026', order: 0 },
  { id: 'gideon-virtual', title: 'Gideon Virtual via Zoom', schedule: 'Thursdays 8–9 PM', order: 1 },
  { id: 'third-sat', title: 'Hybrid corporate (third Saturday)', schedule: 'Monthly', order: 2 },
  { id: 'revival-q', title: 'Gideon Prayer Revival', schedule: 'Quarterly — 1st Sat Jan/Apr/Jul/Oct', order: 3 },
  { id: 'podcast', title: 'Podcast', schedule: 'Regular episodes', order: 4 },
];

export const getGideonEvents = () => GIDEON_EVENTS_SEED;
